import React from 'react';

type ToggleHook<T extends string> = (toggle: T) => boolean;

type Props<FT extends string> = {
  fallback?: React.ComponentType<React.PropsWithChildren<{}>>;
  feature: FT;
};

export const provideToggleGuard =
  <Feature extends string>(
    useFeatureToggle: ToggleHook<Feature>,
    // eslint-disable-next-line react/display-name
  ): React.FC<React.PropsWithChildren<Props<Feature>>> =>
  ({ children, fallback: Fallback, feature }) => {
    if (useFeatureToggle(feature)) {
      return <>{children}</>;
    } else if (Fallback) {
      return <Fallback />;
    }

    return null;
  };
